<template>
  <ul
    class="nav nav-tabs switch-tabs gb-text-2"
    role="tablist"
    aria-label="Library Tabs">
    <li :class="{ 'active': studentsPage}">
      <router-link
        v-if="!studentsPage"
        :to="{name: 'Library'}"
        replace
        aria-selected="false"
        aria-controls="students-tab-panel"
        id="students-tab"
        role="tab"
      >Folders</router-link>
      <a
        href="#"
        v-if="studentsPage"
        aria-selected="true"
        aria-controls="students-tab-panel"
        id="students-tab"
        role="tab"
        @click.prevent>Folders</a>
    </li>
    <li :class="{ 'active': !studentsPage}">
      <router-link
        v-if="studentsPage"
        :to="{name: 'AllResourcesPage'}"
        replace
        role="tab"
        aria-selected="false"
        aria-controls="all-resources-tab-panel"
        id="all-resources-tab"
      >All resources</router-link>
      <a
        v-if="!studentsPage"
        href="#"
        @click.prevent
        role="tab"
        aria-selected="true"
        aria-controls="all-resources-tab-panel"
        id="all-resources-tab"
      >All resources</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LibraryTabs',
  props: {
    activeTab: {
      type: String,
      required: true,
      validator: function(val) {
        return ['Students', 'All Resources'].indexOf(val) > -1
      }
    }
  },
  computed: {
    studentsPage() {
      return this.activeTab === 'Students'
    }
  }
}
</script>

<style scoped lang="less">
.switch-tabs {
  border-color: #aaaaaa;
  li:not(.active):hover a {
    text-decoration: underline;
    background: none;
    border-color: transparent;
  }
  li.active {
    font-weight: 700;
    a {
      border-color: #aaaaaa;
      border-bottom-color: transparent;
    }
  }
  border-bottom-color: #aaaaaa;
  margin-bottom: 20px;
}
</style>
